
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tug/apply",
      function () {
        return require("private-next-pages/tug/apply/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tug/apply"])
      });
    }
  